<template>
    <v-row
        class="my-0 content-row"
        :class="isMobile ? 'pb-6' : ''"
    >
        <v-col class="pa-0">
            <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="time-entries-table"
                :class="isMobile ? 'mobile-entries-table' : ''"
            >
                <thead>
                    <tr>
                        <th
                            v-for="(header, index) in controller.model.getHeaders()"
                            :key="index"
                            class="caption"
                            :style="header.width ? 'width: ' + header.width + 'px' : ''"
                        >
                            {{ header.title }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="isMobile">
                        <td
                            :colspan="controller.model.getHeaders().length"
                            class="subtitle"
                        >
                            {{ $t("Add new") }}
                        </td>
                    </tr>
                    <template v-for="(time_entry, index) in controller.model.timeEntries">
                        <template>
                            <tr
                                :key="index"
                                :class="[
                                    index === 0 ? 'data-row-0' : 'data-row-1',
                                    time_entry.id === 0 || time_entry.running ? 'new' : ''
                                ]"
                            >
                                <v-lazy tag="td" class="ico" :value="index === 0 ? true : null">
                                    <BillableButton
                                        v-if="!(index === 0 && isReadOnly)"
                                        :disabled="isReadOnly"
                                        :show-label="true"
                                        :value="time_entry.billable"
                                        @change="controller.toggleBillable(time_entry)"
                                    />
                                </v-lazy>
                                <v-lazy tag="td" v-if="!isMobile" class="txt subtitle" :value="index === 0 ? true : null">
                                    <span>
                                        {{
                                            time_entry.id === 0
                                                ? $t("New time entry")
                                                : (String(controller.model.timeEntries[0].task_id) === timerModule.task_id.value && timerModule.status.value === 'running') && index === 0
                                                    ? $t("In progress")
                                                    : controller.model.adminView
                                                        ? time_entry.person_name
                                                        : ""
                                        }}
                                    </span>
                                </v-lazy>

                                <v-lazy
                                    tag="td"
                                    class="inp"
                                    :value="index === 0 ? true : null"
                                >
                                    <date-picker
                                        :value="controller.model.getStartDate(time_entry)"
                                        @input="controller.model.datePicked(time_entry, $event)"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                type="text"
                                                readonly
                                                :value="time_entry.start | format_date"
                                                :class="time_entry.date_error != null ? 'validation-error' : ''"
                                                :disabled="isReadOnly"
                                                style="width: 100%"
                                                class="pt-0 mt-0 tabular-nums"
                                                hide-details
                                                solo
                                                v-on="on"
                                                @focus="$event.target.select()"
                                            />
                                        </template>
                                    </date-picker>
                                </v-lazy>
                                <v-lazy
                                    tag="td"
                                    class="inp"
                                    :value="index === 0 ? true : null"
                                >
                                    <v-menu
                                        right
                                        offset-y
                                        :disabled="!(index === 0 && controller.model.getStartTimeActions()) || isReadOnly"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :value="controller.model.getTimeEntryFormattedStart(time_entry)"
                                                type="text"
                                                :class="time_entry.start_time_error != null ? 'validation-error' : ''"
                                                v-on="on"
                                                solo
                                                :error-messages="controller.model.timeEntryErrors[index] ? controller.model.timeEntryErrors[index].start : ''"
                                                hide-details
                                                class="mt-0 pt-0 tabular-nums"
                                                style="width: 100%;"
                                                @focus="$event.target.select()"
                                                @change="controller.setStartTime(time_entry, $event)"
                                            />
                                        </template>
                                        <v-list>
                                            <v-list-item v-if="controller.model.getStartTimeActions()" @click="controller.setLastTime(controller.model.getStartTimeActions().time)">
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ controller.model.getStartTimeActions().text }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-lazy>
                                <td class="inp">
                                    <div v-if="controller.model.getDayDifference(time_entry)" class="plus-days">
                                        {{ controller.model.getDayDifference(time_entry) }}
                                    </div>
                                    <v-lazy :value="index === 0 ? true : null">
                                        <v-text-field
                                            :value="controller.model.getTimeEntryFormattedEnd(time_entry)"
                                            type="text"
                                            :class="time_entry.end_time_error != null ? 'validation-error' : ''"
                                            :hidden="index === 0 && isReadOnly"
                                            :disabled="isReadOnly"
                                            style="width: 100%;"
                                            hide-details
                                            class="mt-0 pt-0 tabular-nums"
                                            solo
                                            @focus="$event.target.select()"
                                            @keydown="time_entry.dirty = true"
                                            @change="controller.setEndTime(time_entry, $event)"
                                        />
                                    </v-lazy>
                                </td>
                                <v-lazy tag="td" class="inp" :value="index === 0 ? true : null">
                                    <v-text-field
                                        ref="duration"
                                        :value="controller.model.getTimeEntryFormattedDuration(time_entry)"
                                        type="text"
                                        :class="time_entry.duration_error != null ? 'validation-error' : ''"
                                        :hidden="index === 0 && isReadOnly"
                                        :disabled="isReadOnly"
                                        class="mt-0 pt-0 tabular-nums"
                                        hide-details
                                        solo
                                        style="width: 100%;"
                                        @focus="$event.target.select()"
                                        @keydown="time_entry.dirty = true"
                                        @change="controller.setDuration(time_entry, $event)"
                                    />
                                </v-lazy>
                                <v-lazy tag="td" class="btn" :class="index === 0 && !isMobile ? 'pb-2' : ''" :value="index === 0 ? true : null">
                                    <div class="d-flex pl-1">
                                        <div :style="time_entry.dirty ? 'visibility: visible' : 'visibility: hidden'" class="d-flex">
                                            <icon-button
                                                v-if="isMobile"
                                                :disabled="isReadOnly || savingTimeEntry"
                                                @click="saveTimeEntry(time_entry, index)"
                                            >
                                                mdi-content-save
                                            </icon-button>
                                            <primary-button
                                                v-else
                                                :disabled="isReadOnly || savingTimeEntry"
                                                @click="saveTimeEntry(time_entry, index)"
                                            >
                                                {{ $t('Ok') }}
                                            </primary-button>
                                        </div>
                                        <template v-if="!isMobile">
                                            <div>
                                                <v-tooltip :disabled="!time_entry.description" right max-width="300">
                                                    <template v-slot:activator="{ on }">
                                                        <icon-button
                                                            :on="on"
                                                            :color="time_entry.description ? 'main' : 'n3'"
                                                            :icon="time_entry.description ? 'CommentFilled' : 'MessageSquare'"
                                                            @click="controller.editTimeEntryComment(index)"
                                                        />
                                                    </template>
                                                    <span style="overflow-wrap: break-word;">{{ time_entry.description }}</span>
                                                </v-tooltip>
                                            </div>
                                            <div>
                                                <icon-button
                                                    v-if="time_entry.id > 0"
                                                    :disabled="isReadOnly"
                                                    icon="Trash2"
                                                    @click.stop="delete_time_entry(time_entry.id)"
                                                />
                                            </div>
                                        </template>
                                        <template v-else>
                                            <action-menu
                                                :items="getMobileActions(time_entry)"
                                                @action="getMobileActions(time_entry)[$event].action(index)"
                                            />
                                        </template>
                                    </div>
                                </v-lazy>
                            </tr>
                            <tr v-if="isMobile && index === 0" :key="index">
                                <td
                                    :colspan="controller.model.getHeaders().length"
                                    class="subtitle"
                                >
                                    {{ $t("History") }}
                                </td>
                            </tr>
                        </template>
                    </template>
                </tbody>
            </table>
        </v-col>
        <v-col cols="12" v-if="controller.model.timeEntries && controller.model.timeEntries.length >= currentLimit">
            <v-row no-gutters justify="center">
                <span class="text-center body-2 grey--text">
                    <v-btn text color="primary" @click="$emit('load-more')">
                        {{ $t("Load more") }}
                    </v-btn>
                </span>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import BillableButton from "@/views/Task/TimeEntries/BillableButton";
import Controller from "./controller"
import KeyInputPattern from "@/composables/KeyInputPattern";
import {$t} from "@/i18n";
import {computed, ref} from "@vue/composition-api";
import Vue from "vue";
import errorDialog from "@/views/ErrorDialog/errorDialog";
import DialogModule from "@/store/modules/dialog"
import ApiTimeEntry from "@/api/time_entry/timeEntry"
import TimerModule from "@/store/modules/timer"
import TaskModule from "../../../store/modules/task";

export default {
    name: "BillableTable",
    components: {
        BillableButton,
    },
    props: {
        value: {
            type: [Number, Boolean],
            default: null
        },
        isMobile: {
            type: Boolean,
            required: true
        },
        isReadOnly: {
            type: Boolean,
            required: true
        },
        controller: {
            type: Controller,
            required: true
        },
        currentLimit: {
            type: Number,
            required: true
        },
        company: {
            type: Object,
            default: null
        },
        topic: {
            type: Object,
            default: null
        }
    },
    setup(props, ctx) {
        const { inputOnFocus } = KeyInputPattern();
        const dialogModule = DialogModule()
        const timerModule = TimerModule()
        const { closeTask } = TaskModule();
        const locale = computed(function () {
            return Vue.formatting.culture;
        });
        const savingTimeEntry = ref(false)

        const delete_time_entry = function (timeEntryId) {
            dialogModule.setConfirmOptions({
                title: $t("Are you sure to delete this time entry?"),
                confirm_text: $t("Delete"),
                cancel_text: $t("Cancel"),
                action: () => delete_time_entry_confirmed(timeEntryId)
            });
            dialogModule.openConfirmDialog();
        };
        const delete_time_entry_confirmed = async function (timeEntryId) {
            try {
                await ApiTimeEntry.deleteTimeEntry(timeEntryId)
                Vue.remove_from_list(props.controller.model.timeEntries, timeEntryId);
            } catch (ex) {
                errorDialog.showError(ex);
            }
        };

        const getMobileActions = (timeEntry) => {
            let ret = []

            if (timeEntry.id) {
                ret.push({
                    text: $t('Delete'),
                    action: (index) => delete_time_entry(props.controller.model.timeEntries[index].id)
                })
            }

            ret.push({
                text: $t('Comment'),
                action: (index) => props.controller.editTimeEntryComment(index)
            })

            return ret
        }

        const saveTimeEntry = async (time_entry, index) => {
            savingTimeEntry.value = true
            await props.controller.saveTimeEntry(time_entry, index, props.company, props.topic)
            savingTimeEntry.value = false
        }


        return {
            inputOnFocus,
            locale,
            delete_time_entry,
            timerModule,
            getMobileActions,
            saveTimeEntry,
            savingTimeEntry
        }
    }
}
</script>

<style scoped lang="scss">
.mobile-entries-table {
    .v-input ::v-deep {
        .v-input__slot {
            padding-left: 4px !important;
            padding-right: 4px !important;
        }

        .v-input--selection-controls__input {
            margin-right: 8px;
        }
    }
}

.v-input {
    ::v-deep .v-input--switch__thumb {
        &::after {
            content: '';
            width: 16px;
            height: 16px;
            background-size: cover;
            background-image: url('~@/assets/NonBillableIcon-svg.svg');
        }
    }

    &.v-input--is-label-active {
        ::v-deep .v-input--switch__thumb {
            &::after {
                background-image: url('~@/assets/BillableIcon-svg.svg');
            }
        }
    }
}

.v-text-field {
    ::v-deep .v-input__slot {
        border-color: transparent !important;
    }

    &.v-input.error--text {
        ::v-deep .v-input__slot {
            border-color: var(--v-error-base) !important;
        }
    }

    &.v-input--is-focused {
        ::v-deep .v-input__slot {
            border-color: var(--v-primary-base) !important;
        }
    }
}

.data-row-1 {
    .v-text-field {
        ::v-deep .v-input__slot {
            background-color: transparent !important;
        }
    }
}

</style>